import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { BeforeAfter } from "@/components/BeforeAfter";
import { WhyIMR } from "@/components/WhyIMR";
import { IndustryInfo } from "@/components/IndustryInfo";
import { Newsletter } from "@/components/Newsletter";
import { ComingSoon } from "@/components/ComingSoon";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import PaymentSuccess from "@/components/PaymentSuccess";
import PaymentCancel from "@/components/PaymentCancel";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <BeforeAfter />
      <WhyIMR />
      <IndustryInfo />
      <Newsletter />
      <ComingSoon />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
